var defaultColors = Array('#00FF00', '#FFFF00', '#FF0000', '#00FFFF', '#FF00FF');
var nextId = -1;
function AddAnnotationLayer()
{
	var tbody = document.getElementById('AnnotationLayerTable').getElementsByTagName('TBODY')[0];
	var rowCount = document.getElementById('AnnotationLayerTable').rows.length - 1; // exclude
	// header
	// row
	if (rowCount == undefined)
	{
		rowCount = 0;
	}
	var layerNum;
	if (rowCount == 0)
	{
		layerNum = 0;
	}
	else
	{
		var id;
		if (rowCount > -1)
		{
			id = document.getElementById('AnnotationLayerTable').rows[rowCount].id;
			id = id.substr(13);
		}
		else
		{
			id = nextId--;
		}
		layerNum = (Number(id) + 1);

		// don't allow more than one empty Layer name on the page
		if (isset(document.getElementById('AttributePlus' + id)))
		{
			var previousLayerName = document.getElementById('AttributePlus' + id).nextSibling.value;
			if (previousLayerName == '')
			{
				return true;
			}
		}
	}

	var tr = document.createElement("TR");
	tr.id = 'row' + String(layerNum);
	if (rowCount > 1)
	{
		if (document.getElementById('AnnotationLayerTable').rows[rowCount - 1].className == 'row')
		{
			tr.className = 'row-alt';
		}
		else
		{
			tr.className = 'row';
		}
	}
	else
	{
		tr.className = 'row';
	}
	var annotationId = document.createElement("INPUT");
	annotationId.name = 'AnnotationIds[]';
	annotationId.value = 0; // New row needs an ID of 0
	annotationId.readonly = true;
	annotationId.type = 'hidden';
	var img = document.createElement("IMG");
	img.id = 'AttributePlus' + layerNum;
	img.src = '/images/Minus.gif';
	img.className = 'cursorPointer';
	img.onclick = function()
	{
		javascript : ShowHideAttributes(layerNum);
	};
	var inputLayer = document.createElement("INPUT");
	inputLayer.maxlength = '128';
	inputLayer.size = '30';
	inputLayer.size = '30';
	inputLayer.name = 'AnnotationLayerNames[]';
	inputLayer.className = 'Modified';
	inputLayer.value = '';
	inputLayer.setAttribute('OldValue', '0xFFFF');
	inputLayer.onchange = function()
	{
		CheckModified(document.getElementById('AnnotationLayerTable'));
	};
	var td = document.createElement("TD");
	td.appendChild(annotationId);
	td.appendChild(img);
	td.appendChild(inputLayer);
	tr.appendChild(td);

	var inpColor = document.createElement("INPUT");
	inpColor.id = 'Color' + Math.abs(layerNum);
	inpColor.type = 'text';
	inpColor.name = 'Colors[]';
	inpColor.readOnly = true;
	inpColor.className = 'layerColor';
	var mod5 = Math.abs(layerNum - 4) % 5;
	inpColor.style.backgroundColor = defaultColors[mod5];
	inpColor.style.color = defaultColors[mod5];
	inpColor.value = defaultColors[mod5];
	td = document.createElement("TD");
	td.appendChild(inpColor);
	var button = document.createElement("INPUT");
	button.type = 'button';
	button.value = 'Choose Color';
	button.onclick = function()
	{
		showColorPicker(this, inpColor);
	};
	td.appendChild(button);
	tr.appendChild(td);

	var a = document.createElement("A");
	a.href = '#';
	a.innerHTML = "Delete";
	a.onclick = function()
	{
		DeleteAnnotationLayer(layerNum);
		return false;
	};
	td = document.createElement("TD");
	td.appendChild(a);
	tr.appendChild(td);
	tbody.appendChild(tr);

	tr = document.createElement("TR");
	tbody.appendChild(tr);
	tr.id = 'AttributesFor' + layerNum;

	td = document.createElement("TD");
	tr.appendChild(td);
	var tbl = document.createElement("TABLE");
	td.appendChild(tbl);
	tbody = document.createElement("TBODY");
	tbl.appendChild(tbody);

	tr = document.createElement("TR");
	tbody.appendChild(tr);
	td = document.createElement("TD");
	tr.appendChild(td);
	td.style.width = '50px';
	td = document.createElement("TD");
	tr.appendChild(td);
	var b = document.createElement("B");
	td.appendChild(b);
	a = document.createElement("A");
	b.appendChild(a);
	a.href = '#';
	a.onclick = function()
	{
		AddAnnotationAttribute(layerNum);
		return false;
	};
	a.innerHTML = 'Add Attribute to Class';

	tr = document.createElement("TR");
	tbody.appendChild(tr);
	td = document.createElement("TD");
	tr.appendChild(td);
	td = document.createElement("TD");
	tr.appendChild(td);
	tbl = document.createElement("TABLE");
	td.appendChild(tbl);
	tbl.className = 'AttributeTable';
	tbl.id = 'AttributeTable' + layerNum;

	tbody = document.createElement("TBODY");
	tbl.appendChild(tbody);
	tr = document.createElement("TR");
	tbody.appendChild(tr);
	var th = document.createElement("TH");
	th = document.createElement("TH");
	th.className = 'ListTable';
	th.innerHTML = 'Attribute Name';
	tr.appendChild(th);
	th = document.createElement("TH");
	th.className = 'ListTable';
	th.innerHTML = 'Tasks';
	tr.appendChild(th);

	inputLayer.select();

}

function DeleteAnnotationLayer(layerNum)
{
	if (confirm("Are you sure you want to delete this Layer?"))
	{

		var tbody = document.getElementById('AnnotationLayerTable').getElementsByTagName('TBODY')[0];
		tbody.removeChild(document.getElementById('row' + layerNum));
		tbody.removeChild(document.getElementById('AttributesFor' + layerNum));
		var alt = true;
		var count = document.getElementById('AnnotationLayerTable').rows.length; // this
		// includes
		// 1
		// for
		// the
		// header
		// row
		for ( var i = 1; i < count; i += 2)
		{
			alt = !alt;
			if (alt)
			{
				document.getElementById('AnnotationLayerTable').rows[i].className = 'row-alt';
			}
			else
			{
				document.getElementById('AnnotationLayerTable').rows[i].className = 'row';
			}
		}
	}
}

function ShowHideAttributes(layerNum)
{
	var sRow = 'AttributesFor' + layerNum;
	var sPlus = 'AttributePlus' + layerNum;
	var strDisplay = document.getElementById(sRow).style.display;
	if (strDisplay == "none")
	{
		strDisplay = "";
		document.getElementById(sPlus).src = "/Images/Minus.gif";
	}
	else
	{
		strDisplay = "none";
		document.getElementById(sPlus).src = "/Images/Plus.gif";
	}
	document.getElementById(sRow).style.display = strDisplay;
}

function AddAnnotationAttribute(annotationid)
{

	var tableId = 'AttributeTable' + annotationid;
	var tbody = document.getElementById(tableId).getElementsByTagName('TBODY')[0];
	var rowCount = document.getElementById(tableId).rows.length - 1;
	var attribNum;
	if (rowCount == 0)
	{
		attribNum = 0;
	}
	else
	{
		var id = document.getElementById(tableId).rows[rowCount].id;
		var offset = id.search("Attrib");
		id = id.substr(offset + 6);
		attribNum = Number(id) + 1;

		// don't allow more than one empty attribute name for this layer
		var previousAttributeName = document.getElementById('Layer' + annotationid + 'Attrib' + id).firstChild.firstChild.value;
		if (previousAttributeName == '')
		{
			return true;
		}
	}

	var tr = document.createElement("TR");
	tbody.appendChild(tr);
	tr.id = 'Layer' + annotationid + 'Attrib' + attribNum;
	td = document.createElement("TD");
	tr.appendChild(td);
	var inp = document.createElement("INPUT");
	td.appendChild(inp);
	inp.maxlength = '128';
	inp.size = '30';
	inp.name = 'Attributes' + annotationid + '[]';
	inp.value = '';
	inp.setAttribute('OldValue', '0xFFFF');
	inp.className = 'Modified';
	inp.onchange = function()
	{
		CheckModified(document.getElementById('AnnotationLayerTable'));
	};

	td = document.createElement("TD");
	tr.appendChild(td);
	a = document.createElement("A");
	td.appendChild(a);
	a.href = '#';
	a.onclick = function()
	{
		DeleteAnnotationAttribute(annotationid, attribNum);
		return false;
	};
	a.innerHTML = 'Delete';

	inp.select();
}

function DeleteAnnotationAttribute(annotationid, attribNum)
{
	if (confirm("Are you sure you want to delete this attribute?"))
	{

		var tableId = 'AttributeTable' + annotationid;
		var tbody = document.getElementById(tableId).getElementsByTagName('TBODY')[0];
		var rowId = 'Layer' + annotationid + 'Attrib' + attribNum;
		tbody.removeChild(document.getElementById(rowId));
	}
}

function LoadAnnotationsFromXML(XML, Unmodified)
{
	var XMLRootNode = null;
	if (typeof XML == 'string')
	{
		XMLRootNode = parseXML(XML).firstChild;
	}
	else
	{
		XMLRootNode = XML;
	}

	var Table = document.getElementById('AnnotationLayerTable').getElementsByTagName('TBODY')[0];
	while (Table.childNodes.length > 0)
	{
		Table.removeChild(Table.lastChild);
	}
	var newRow = document.createElement("TR");
	var header = document.createElement("TH");
	header.setAttribute('class', 'ListTable');
	header.appendChild(document.createTextNode('Class Name'));
	newRow.appendChild(header);
	header = document.createElement("TH");
	header.setAttribute('class', 'ListTable');
	header.appendChild(document.createTextNode('Color'));
	newRow.appendChild(header);
	header = document.createElement("TH");
	header.setAttribute('class', 'ListTable');
	header.appendChild(document.createTextNode('Tasks'));
	newRow.appendChild(header);
	Table.appendChild(newRow);
	var AnnotationNode = XMLRootNode.firstChild;
	while (AnnotationNode)
	{
		AddAnnotationLayer();
		NewRow = Table.rows[Table.rows.length - 2];
		var LayerNumber = NewRow.getAttribute('Id').substr(3);
		ShowHideAttributes(LayerNumber);

		var RowData = NewRow.getElementsByTagName('INPUT');
		RowData[0].value = AnnotationNode.getAttribute('Id');
		RowData[1].value = AnnotationNode.getAttribute('Name');
		if (Unmodified)
		{
			RowData[1].setAttribute('OldValue', RowData[1].value);
			removeClass(RowData[1], 'Modified');
		}

		var Color = baseConverter(AnnotationNode.getAttribute('LineColor'), 10, 16);
		Color = '#000000'.substr(0, 7 - Color.length) + Color;
		Color = '#' + Color.substr(5, 2) + Color.substr(3, 2) + Color.substr(1, 2);
		RowData[2].value = Color;
		RowData[2].style.color = Color;
		RowData[2].style.backgroundColor = Color;

		var AttributeTable = document.getElementById('AttributeTable' + LayerNumber).getElementsByTagName('TBODY')[0];
		var AttributesNode = AnnotationNode.getElementsByTagName('Attributes');
		if (AttributesNode.length == 0)
		{
			AttributesNode = AnnotationNode.getElementsByTagName('ATTRIBUTES');
		}

		var AttributeNode = AttributesNode[0].firstChild;
		while (AttributeNode)
		{
			AddAnnotationAttribute(LayerNumber);
			var AttributeNames = AttributeTable.getElementsByTagName('INPUT');
			var AttributeName = (AttributeNames.length ? AttributeNames[AttributeNames.length - 1] : AttributeNames);

			AttributeName.value = AttributeNode.getAttribute('Name');
			if (Unmodified)
			{
				AttributeName.setAttribute('OldValue', AttributeName.value);
				removeClass(AttributeName, 'Modified');
			}

			AttributeNode = AttributeNode.nextSibling;
		}

		AnnotationNode = AnnotationNode.nextSibling;
	}

}

function SaveAnnotationsAsXML()
{
	var BadChars = '<>",|&\'';
	var Annotations = '<Annotations>';
	var AnnotationRows = document.getElementById('AnnotationLayerTable').rows;
	for ( var i = 1; i < AnnotationRows.length; i += 2)
	{
		var LayerRow = AnnotationRows[i];
		var LayerId = LayerRow.getAttribute('id').substr(3);

		var RowData = LayerRow.getElementsByTagName('INPUT');
		var Name = RowData[1].value;
		if (Name == '')
		{
			return 'Class names cannot be blank';
		}
		if (strpbrk(Name, BadChars) != -1)
		{
			return 'Class names cannot contain any of these characters:<br/>&nbsp;&nbsp;&nbsp;&nbsp;' + BadChars;
		}
		var Color = RowData[2].value.substr(1);
		Color = Color.substr(4, 2) + Color.substr(2, 2) + Color.substr(0, 2);
		Color = baseConverter(Color, 16, 10);
		var annotationId = RowData[0].value;
		if (annotationId == 0)
		{
			annotationId = nextId--;
		}
		Annotations += '<Annotation Id="' + escapeXML(annotationId) + '" Name="' + escapeXML(Name)
				+ '" Selected="0" NameReadOnly="1" ReadOnly="0" Type="4" LineColor="' + escapeXML(Color) + '" LineColorReadOnly="1" '
				+ 'Visible="1" MarkupImagePath="">';

		Annotations += '<Attributes>';

		var AttributesTable = document.getElementById('AttributeTable' + LayerId).getElementsByTagName('TBODY')[0];
		for ( var j = 1; j < AttributesTable.rows.length; j++)
		{
			Name = AttributesTable.rows[j].getElementsByTagName('INPUT')[0].value;
			if (Name == '')
			{
				return 'Attribute names cannot be blank';
			}
			Annotations += '<Attribute Name="' + escapeXML(Name) + '" Value="" NameReadOnly="1">' + 'Id="' + nextId-- + '</Attribute>';
		}

		Annotations += '</Attributes>';

		Annotations += '<Regions><RegionAttributeHeaders>';
		Annotations += '<AttributeHeader Id="-1" Name="Region" ColumnWidth="45"></AttributeHeader>';
		Annotations += '</RegionAttributeHeaders></Regions>';

		Annotations += '</Annotation>';
	}

	Annotations += '</Annotations>';
	return encodeURIComponent(Annotations);
}

function SaveTemplateAJAX()
{
	document.createElement('Annotations');
	var Text = SaveAnnotationsAsXML();
	var ErrDiv = document.getElementById('Genie Training SetErrorDiv');
	if (isset(ErrDiv))
	{
		if (Text.substr(0, 3) != "%3C")
		{
			ErrDiv.style.display = '';
			ErrDiv.innerHTML = Text;
			return;
		}
		else
		{
			ErrDiv.innerHTML = '';
			ErrDiv.style.display = 'none';
		}
	}
	HTTPRequest('SaveTemplate.php', 'POST', 'Id=' + document.getElementById('TrainingSetId').value + '&XML=' + Text, ReceiveTemplateAJAX);
}

function ReceiveTemplateAJAX(http_request)
{
	if ((http_request.readyState == 4) && (http_request.status == 200))
	{
		var Response = ParseJson(http_request.responseText);
		if (Response)
		{
			var responseXML = parseXML(Response);
			if (typeof (responseXML) === 'undefined' || typeof (responseXML.documentElement) === 'undefined'
				|| typeof (responseXML.documentElement.nodeName) === 'undefined' || (responseXML.documentElement.nodeName != 'Annotations'))
			{
				return;
			}

			LoadAnnotationsFromXML(responseXML.documentElement, true);
		}
	}
}

function LoadTemplate()
{
	var LoadTemplate = window
			.open('LoadTemplate.php', 'Templates', 'width=440,height=400,status=no,top=200,left=500,dependent=yes,alwaysRaised=yes,scrollbars,resizable');
	LoadTemplate.opener = window;
	LoadTemplate.focus();
}
